module.exports = __webpack_public_path__ + "static/media/022.b6ca5362.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/022.jpg
// module id = 369
// module chunks = 0